import { Controller } from "@hotwired/stimulus";
import Uppy from "@uppy/core";
import Russian from "@uppy/locales/lib/ru_RU";
import Tus from "@uppy/tus";
import { client } from "./../components/Client";
import Dashboard from '@uppy/dashboard';
import { post, put, destroy } from "@rails/request.js";

import "@uppy/core/dist/style.min.css";
import "@uppy/dashboard/dist/style.min.css";

export default class extends Controller {
  static targets = ["container", "videoImg", "closeBtn", "trigger"];
  static values = {
    maxNumberOfFiles: {
      type: Number,
      default: 1
    },
    allowedFileTypes: {
      type: String,
      default: "image/*,video/*,audio/*,application/*"
    },
    autoProceed: {
      type: Boolean,
      default: false
    },
    dashboardHeight: {
      type: Number,
      default: 550
    },
    courseId: {
      type: Number,
      default: 0,
    },
    sectionId: {
      type: Number,
      default: 0,
    },
    callClient: {
      type: Boolean,
      default: false,
    },
    clientUrl: {
      type: String,
      default: "",
    },
    confirmMessage: {
      type: String,
      default: "",
    },
    inline: {
      type: Boolean,
      default: true,
    },
    targetSelector: {
      type: String,
      default: "",
    }
  }

  connect() {
    const extraOptions = {
      height: this.dashboardHeightValue,
      trigger: this.hasTriggerTarget ? this.triggerTarget : null,
      disablePageScrollWhenModalOpen: false,
    }

    this.locale = window.locale == "ru" ? Russian : "en_EN";
    this.uppy = new Uppy({
      debug: true,
      restrictions: {
        maxNumberOfFiles: this.maxNumberOfFilesValue,
        allowedFileTypes: this.allowedFileTypesValue.split(",")
      },
      autoProceed: this.autoProceedValue,
      locale: this.locale,
    })
      .use(Dashboard, { inline: this.inlineValue, target: this.hasContainerTarget ? this.containerTarget : this.targetSelectorValue, ...extraOptions })
      .use(Tus, { endpoint: window.upload_endpoint, chunkSize: 5 * 1024 * 1024 })

    this.uppy.on("upload-success", (file, response) => {
      const fileData = {
        title: file.name,
        file_orig_name: file.name,
        file_url: response.uploadURL,
        file_size: file.size,
        file_type: file.meta.type
      }

      if (this.callClientValue) {
        const lectionData = { content_type: "file" }
        client.createCourseFileLection(this.courseIdValue, this.sectionIdValue, lectionData, fileData)
          .then(async (_response) => {
            const res = await post(this.clientUrlValue, { responseKind: "turbo-stream" });
            console.log(`createCourseFileLection response: ${res}`);
          });
      } else {
        this.#createFile(fileData);
      }
    });

    if (this.callClientValue) {
      this.uppy.on("dashboard:modal-closed", () => {
        this.closeModal();
      });
    }
  }

  async delete() {
    if (confirm(this.confirmMessageValue)) {
      // this.videoImgTarget.classList.add("hidden");
      await destroy(this.clientUrlValue, { responseKind: "turbo-stream" });
    }
  }

  closeModal() {
    if (this.hasCloseBtnTarget) {
      this.closeBtnTarget.click();
    }
    const dispatch = this.dispatch;

    setTimeout(() => {
      dispatch("closeModal");
    }, 100);
  }

  #createFile(fileData) {
    client.createFile(fileData)
      .then(async (response) => {
        if (response.success) {
          await put(this.clientUrlValue, {
            responseKind: "turbo-stream", body: {
              "course": {
                "promo_video_id": response.file_id,
              }
            }
          });
        } else {
          console.error("something went wrong with the createFile endopint");
          console.log(response);
        }
      })
  }
}
